export default function PageJsonLd() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Обратная связь и сложные разговоры — тренинг для руководителей",
        "description": "Тренинг для руководителей по обратной связи и сложным разговорам с сотрудниками: критика, ошибки, конфликты, невыполнение задач, мотивация и развитие сотрудников. Корпоративное обучение.",
        "url": "https://business-training.by/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory",
        "isPartOf": {
          "@type": "WebSite",
          "name": "Business Training",
          "url": "https://business-training.by"
        }
      },
      {
        "@type": "Service",
        "name": "Тренинг по обратной связи и сложным разговорам",
        "description": "Корпоративное обучение руководителей навыкам обратной связи и проведения сложных разговоров с сотрудниками: как обсуждать ошибки, невыполнение задач, конфликты и результаты так, чтобы разговор приводил к изменениям, а не к обиде или сопротивлению.",
        "provider": {
          "@type": "Person",
          "name": "Алексей Сивко",
          "jobTitle": "Бизнес-тренер, консультант по продажам и управлению, фасилитатор, сертифицированный коуч ICU",
          "url": "https://business-training.by/o-trenere",
          "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
        },
        "areaServed": [
          { "@type": "Country", "name": "Беларусь" },
          { "@type": "Country", "name": "Россия" },
          { "@type": "Country", "name": "Казахстан" },
          { "@type": "Country", "name": "Израиль" }
        ],
        "serviceType": "обучение руководителей, обратная связь, сложные разговоры, управленческие коммуникации, конструктивная критика",
        "url": "https://business-training.by/menedzhment-i-liderstvo/obratnaya-svyaz-i-slozhnye-razgovory"
      },
      {
        "@type": "Person",
        "name": "Алексей Сивко",
        "jobTitle": "Бизнес-тренер",
        "description": "18+ лет практики в корпоративном обучении. 100+ корпоративных проектов, 450+ тренингов и бизнес-сессий, 4500+ участников. Средняя оценка участников — 9,09/10. Работал с компаниями Беларуси, России, Казахстана и Израиля.",
        "url": "https://business-training.by/o-trenere",
        "sameAs": ["https://www.linkedin.com/in/alekseysivko", "https://t.me/a_sivko"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Что включает тренинг по обратной связи?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Тренинг включает алгоритмы и практическую отработку обратной связи: как отделять факты от оценок, говорить о поведении а не о личности, формулировать ожидания, сохранять конструктивный тон, работать с эмоциональной реакцией сотрудника и фиксировать договорённости. Программа адаптируется под уровень руководителей и реальные управленческие ситуации компании."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю правильно давать обратную связь сотруднику?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Правильная обратная связь строится на фактах а не на оценках: описать конкретную ситуацию, назвать наблюдаемое поведение, объяснить влияние на результат, сформулировать ожидания и договориться о дальнейших действиях. Принципиально важно проводить разговор своевременно, не накапливая проблемы, и завершать его конкретной договорённостью, а не просто высказанным мнением."
            }
          },
          {
            "@type": "Question",
            "name": "Как говорить сотруднику о его ошибках?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Обсуждение ошибки должно фокусироваться на том, что произошло и как избежать повторения, а не на поиске виноватого. Важно: описать факт ошибки, вместе проанализировать причины, обсудить последствия, договориться о корректирующих действиях и определить, как будет контролироваться результат. Нельзя переходить на личность сотрудника или публично критиковать."
            }
          },
          {
            "@type": "Question",
            "name": "Как провести сложный разговор с сотрудником?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Сложный разговор требует подготовки: чётко определить проблему и желаемый результат, подготовить факты, выбрать подходящее время и место. В ходе разговора — сохранять спокойный тон, дать сотруднику высказаться, задавать вопросы для выяснения причин, не уходить от темы. Завершать разговор конкретным планом действий и договорённостью о следующей проверке."
            }
          },
          {
            "@type": "Question",
            "name": "Как давать критическую обратную связь и не демотивировать сотрудника?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Критическая обратная связь не демотивирует, если она конструктивна и направлена на улучшение, а не на осуждение. Ключевые принципы: говорить о поведении а не о личности, использовать конкретные примеры, объяснять почему это важно, дать сотруднику возможность высказаться и предложить своё видение решения. Важно чтобы сотрудник вышел из разговора с пониманием что конкретно нужно изменить, а не с ощущением что его оценили негативно."
            }
          },
          {
            "@type": "Question",
            "name": "Как говорить о невыполнении задач?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Разговор о невыполнении задачи строится вокруг конкретных договорённостей, которые были нарушены. Руководитель напоминает о договорённости, констатирует факт невыполнения, выясняет причины, обсуждает последствия и договаривается о новом сроке с конкретными действиями. Принципиально — не принимать обещание исправиться без анализа причин и плана действий."
            }
          },
          {
            "@type": "Question",
            "name": "Как руководителю работать с конфликтами?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Работа руководителя с конфликтами начинается с признания проблемы, а не её игнорирования. Важно выслушать каждую сторону отдельно, затем провести совместный разговор, фокусируясь на рабочих задачах и фактах, а не на личной неприязни. Цель — не найти кто прав, а договориться о том, как участники будут работать дальше для достижения общего результата."
            }
          },
          {
            "@type": "Question",
            "name": "Подходит ли тренинг для новых руководителей?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, для новых руководителей тренинг особенно полезен. Они часто испытывают наибольшие сложности с обратной связью: боятся испортить отношения с бывшими коллегами, не имеют опыта сложных разговоров, не знают как выстроить управленческую коммуникацию. Программа даёт базовые инструменты и практическую отработку, которая помогает новым руководителям быстрее освоить эту компетенцию."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли адаптировать программу под нашу компанию?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, адаптация — обязательный этап подготовки. Мы не используем шаблонные решения. Сначала разбираемся в реальных управленческих ситуациях компании: с какими сложными разговорами сталкиваются руководители, какие проблемы с обратной связью существуют. После этого программа настраивается под конкретный контекст, уровень руководителей и отраслевую специфику."
            }
          },
          {
            "@type": "Question",
            "name": "Сколько длится обучение?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Продолжительность зависит от задач компании и выбранного формата. Корпоративный тренинг обычно длится 1–2 дня интенсивной практической работы. Модульная программа может занимать несколько недель с практикой между модулями. Точный формат и продолжительность определяются после диагностики потребностей компании и обсуждения целей обучения."
            }
          },
          {
            "@type": "Question",
            "name": "Можно ли использовать реальные ситуации сотрудников?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, мы активно используем реальные управленческие ситуации участников в обучении. Это делает программу максимально практичной: руководители разбирают не абстрактные кейсы, а свои конкретные сложные разговоры и ситуации с обратной связью. При необходимости соблюдается конфиденциальность реальных имён и обстоятельств."
            }
          },
          {
            "@type": "Question",
            "name": "Есть ли сопровождение после тренинга?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Да, сопровождение возможно и часто является частью программы. После обучения мы можем разбирать реальные сложные разговоры, которые провели руководители, анализировать что получилось а что нет, и помогать корректировать подход. Это особенно важно для закрепления навыков и переноса инструментов в ежедневную управленческую практику."
            }
          }
        ]
      }
    ]
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}